import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgEth = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#eth_svg__a)'>
      <path fill='#627EEA' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='#fff'
        d='M7 12.147 11.999 4v5.913zM11.999 15.978v4.019L7 13.077z'
      />
      <path
        fill='#fff'
        fillOpacity={0.2}
        d='m11.999 15.049 4.998-2.902-4.998-2.232z'
      />
      <path
        fill='#fff'
        fillOpacity={0.6}
        d='M11.999 4v5.913l4.998 2.234zM11.999 15.979v4.018L17 13.077zM11.999 15.049 7 12.147l4.999-2.232z'
      />
    </g>
    <defs>
      <clipPath id='eth_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgEth)
export default ForwardRef
